import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Globe"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3.75 8.25C3.75 4.52208 6.77208 1.5 10.5 1.5C14.2279 1.5 17.25 4.52208 17.25 8.25C17.25 11.9779 14.2279 15 10.5 15C6.77208 15 3.75 11.9779 3.75 8.25ZM21.7495 9.00002C21.7524 6.21537 20.6426 3.54498 18.667 1.58252L17.6095 2.64002C20.9227 6.17827 20.8384 11.7049 17.419 15.1405C13.9995 18.5761 8.47337 18.6864 4.91953 15.39L3.83203 16.4175C5.79449 18.3931 8.46488 19.5029 11.2495 19.5V21.75H8.24953V23.25H15.7495V21.75H12.7495V19.38C17.9109 18.635 21.7434 14.2149 21.7495 9.00002ZM10.5 3C13.3995 3 15.75 5.35051 15.75 8.25C15.75 11.1495 13.3995 13.5 10.5 13.5C7.60051 13.5 5.25 11.1495 5.25 8.25C5.25 5.35051 7.60051 3 10.5 3Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Globe.vue"]]);
